import _ from 'lodash'
import { ENTRIES_LOADED } from '../constants';

const initialState = {byContentfulId: {}, all:[]};

export default function update(state = initialState, action) {
    switch (action.type) {
        case ENTRIES_LOADED:
            if(action.entries.requestable) {
                const result = initialState;
                Object.keys(action.entries.requestable).map(key => {
                    result.byContentfulId[key] = action.entries.requestable[key];
                    result.all.push(action.entries.requestable[key]);
                })
                return result
            }
            break;
    }
    return state;
}
